module.exports = __webpack_public_path__ + "assets/img/img91.7f402a9d.png";